<template>
  <div
    :class="[
      {
        'ps-is-active': isActive
      }
    ]"
    @transitionend="handleTransitionEnd"
    class="ps-card-peek ps-absolute ps-bottom-0 ps-w-full"
  >
    <div
      class="ps-decorator ps-rounded ps-px-4 ps-bg-brand-gray-100 ps-text-white ps-h-16 ps-flex ps-items-center"
    >
      <h3
        v-if="isReady"
        class="ps-text-xl ps-text-brand-brown-800 ps-font-bold"
      >
        {{ card.name }}
      </h3>
    </div>
    <div class="ps-h-32 ps-w-full bg-brand-brown-100"></div>
  </div>
</template>

<script>
import {
  mapState,
  mapGetters,
  mapActions,
  mapMutations
} from '@picnic-software/vuex'
import {
  CARD_CREATE,
  ROUTE_CONTROLS,
  ROUTE_CARD,
  ROUTE_CARD_PEEK
} from '@/common/constants'

export default {
  name: 'CardPeek',

  data() {
    return {
      id: null,
      card: {},
      isReady: false,
      isError: false
    }
  },
  computed: {
    ...mapState({
      cardId: state => state.router.cardPeekId
    }),

    isActive() {
      return this.cardId
    }
  },
  watch: {
    cardId(val) {
      if (val) return this.loadCard()
    }
  },

  methods: {
    ...mapActions({
      getCard: 'dots/get'
    }),
    ...mapMutations({
      routerTo: 'router/to'
    }),
    async loadCard() {
      this.isReady = false
      await this.fetchCard()
      await this.$nextTick()
      this.isReady = true
    },
    async fetchCard() {
      const { id, card, pages, browsers, comments } = await this.getCard(
        this.cardId
      )
      console.log('card FETCHED', id, card, pages, browsers, comments)
      this.id = id
      this.card = card
      if (!this.card || !this.card.id) {
        this.isError = true
        return
      }
    },

    handleTransitionEnd() {
      console.log('transitionend')
    }
  }
}
</script>

<style lang="postcss" scoped>
.ps-card-peek {
  transition: all 250ms ease;
  will-change: transform;
  transform: translateX(-50%) translateY(calc(100% + 0.5rem));
  max-width: 325px;
  opacity: 1;
  left: 50%;

  &.ps-is-active {
    transform: translateX(-50%) translateY(0);
  }
}

.ps-decorator {
  box-shadow: 0 0 0 6px rgba(255, 111, 89, 0.8),
    0 2.8px 2.2px rgba(0, 0, 0, 0.02), 0 6.7px 5.3px rgba(0, 0, 0, 0.028),
    0 12.5px 10px rgba(0, 0, 0, 0.035), 0 22.3px 17.9px rgba(0, 0, 0, 0.042),
    0 41.8px 33.4px rgba(0, 0, 0, 0.05), 0 100px 80px rgba(0, 0, 0, 0.07) !important;
}
</style>
